.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: var(--r-round);
  font-weight: 600;
  white-space: nowrap;
  transition:
    transform var(--dur-press) var(--ease),
    background-color var(--dur-fade) var(--ease),
    opacity var(--dur-fade) var(--ease);
  user-select: none;
}

.button:active {
  transform: scale(0.97);
}

.button:disabled {
  opacity: 0.45;
  cursor: default;
  transform: none;
}

.md {
  height: 48px;
  padding-inline: 20px;
  font-size: 15px;
}

.sm {
  height: 36px;
  padding-inline: 14px;
  font-size: 14px;
}

.wide {
  width: 100%;
}

.primary {
  background: var(--ink);
  color: var(--on-ink);
}

.quiet {
  background: var(--sunken);
  color: var(--text);
}

.line {
  background: transparent;
  color: var(--text);
  box-shadow: inset 0 0 0 1px var(--line-strong);
}

.ghost {
  background: transparent;
  color: var(--text);
}

.ghost:hover,
.line:hover {
  background: var(--press);
}

.danger {
  background: color-mix(in srgb, var(--bad) 14%, transparent);
  color: var(--bad-ink);
}

.iconButton {
  display: inline-grid;
  place-items: center;
  width: var(--tap);
  height: var(--tap);
  border-radius: var(--r-round);
  color: var(--text);
  flex-shrink: 0;
  transition:
    background-color var(--dur-fade) var(--ease),
    transform var(--dur-press) var(--ease);
}

.iconButton:active {
  transform: scale(0.94);
}

.icon_plain:hover {
  background: var(--press);
}

.icon_filled {
  background: var(--sunken);
}

.icon_sky {
  color: var(--sky-ink, #fff);
  background: color-mix(in srgb, var(--sky-ink, #fff) 14%, transparent);
}
